import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "placeholderHeight", "placeholderWidth", "playInLoop"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import useTestId from '@ori/testid-generator';
import { useRef, useCallback, useEffect, useState } from 'react';
import { PlayButton, PlayIcon, Player, Root } from "./styles";
import { VIDEO, VIDEO_PLAYER, VIDEO_PLAY_BUTTON } from "../../common";
import { ImagePlaceholder } from "../ImagePlaceholder";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Video = function Video(_ref) {
  var src = _ref.src,
    placeholderHeight = _ref.placeholderHeight,
    placeholderWidth = _ref.placeholderWidth,
    playInLoop = _ref.playInLoop,
    htmlDivElementProps = _objectWithoutProperties(_ref, _excluded);
  var playerRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPlaying = _useState2[0],
    setIsPlaying = _useState2[1];
  var _useTestId = useTestId(),
    getTestId = _useTestId.getTestId;
  var _useState3 = useState(true),
    _useState4 = _slicedToArray(_useState3, 2),
    isPlaceholderVisible = _useState4[0],
    setIsPlaceholderVisible = _useState4[1];
  useEffect(function () {
    if (!playerRef.current) {
      return;
    }
    if (isPlaying) {
      playerRef.current.play();
    } else {
      playerRef.current.pause();
    }
  }, [isPlaying, playerRef]);
  var toggleVideo = useCallback(function () {
    setIsPlaying(function (prevState) {
      return !prevState;
    });
  }, []);
  var hideImagePlaceholder = useCallback(function () {
    setIsPlaceholderVisible(false);
  }, []);
  return /*#__PURE__*/_jsxs(Root, _objectSpread(_objectSpread({}, htmlDivElementProps), {}, {
    "data-testid": getTestId(VIDEO),
    children: [isPlaceholderVisible ? null : /*#__PURE__*/_jsx(PlayButton, {
      isPlaying: isPlaying,
      role: "button",
      tabIndex: -1,
      "data-testid": getTestId(VIDEO_PLAY_BUTTON),
      onClick: toggleVideo,
      children: /*#__PURE__*/_jsx(PlayIcon, {})
    }), isPlaceholderVisible ? /*#__PURE__*/_jsx(ImagePlaceholder, {
      isLoadingPlaceholder: true,
      isSquare: placeholderHeight === undefined && placeholderWidth === undefined,
      height: placeholderHeight,
      width: placeholderWidth
    }) : null, /*#__PURE__*/_jsx(Player, {
      ref: playerRef,
      muted: true,
      playsInline: true,
      loop: playInLoop,
      src: src,
      isPlaceholderVisible: isPlaceholderVisible,
      "data-testid": getTestId(VIDEO_PLAYER),
      onClick: toggleVideo,
      onLoadedData: hideImagePlaceholder
    })]
  }));
};
//# sourceMappingURL=Video.js.map